<template>
    <div :class="{'overlay': true, 'overlay--opened': display}">
        <div class="overlay__wrapper">
            <button class="overlay__close js-overlay__control" v-on:click="$emit('close')">&times; zavřít</button>
            <div class="overlay__content">
                <div class="basicForm basicForm--materialListToMail overlay__item" style="display: block">
                    <slot/>
                </div>
            </div>
        </div>
        <button class="overlay__bg js-overlay__control"></button>
    </div>
</template>

<script>

    export default {
        name: 'CalculationDialog',
        props: {
            display: Boolean
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/dialog/Dialog.vue